import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { companyInfo } from '../data/siteData';
import { EnquiryForm } from '../components/common/EnquiryForm';

export default function ContactPage() {
  return (
    <div data-testid="contact-page" className="pt-20">
      {/* Header */}
      <section className="py-16 md:py-24 bg-[#F8F9FA]">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#47ace2] font-manrope">
            Get in Touch
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-light tracking-tight text-slate-900 font-outfit mt-4">
            Contact Us
          </h1>
          <p className="text-lg text-slate-600 font-manrope mt-4 max-w-2xl">
            Have questions about our projects or services? We'd love to hear from you.
            Reach out to us and our team will get back to you shortly.
          </p>
        </div>
      </section>

      {/* Contact Content */}
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            {/* Contact Info */}
            <div>
              <h2 className="text-2xl font-semibold text-slate-900 font-outfit mb-8">
                Get In Touch
              </h2>

              <div className="space-y-8">
                <div className="flex gap-5">
                  <div className="w-14 h-14 bg-[#F0F8FF] rounded-2xl flex items-center justify-center flex-shrink-0">
                    <MapPin className="w-6 h-6 text-[#47ace2]" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-slate-900 font-outfit mb-1">Office Address</h3>
                    <p className="text-slate-600 font-manrope">{companyInfo.address}</p>
                  </div>
                </div>

                <div className="flex gap-5">
                  <div className="w-14 h-14 bg-[#F0F8FF] rounded-2xl flex items-center justify-center flex-shrink-0">
                    <Phone className="w-6 h-6 text-[#47ace2]" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-slate-900 font-outfit mb-1">Phone</h3>
                    <div className="flex flex-col gap-1">
                      <a
                        href={`tel:${companyInfo.primaryPhone || '+918766551928'}`}
                        className="text-slate-600 hover:text-[#47ace2] font-manrope transition-colors"
                      >
                        +91 8766 551 928 (Primary)
                      </a>
                      <a
                        href={`tel:${companyInfo.secondaryPhone || '07124102028'}`}
                        className="text-slate-500 hover:text-[#47ace2] font-manrope transition-colors text-sm"
                      >
                        0712-4102028 (Landline)
                      </a>
                    </div>
                  </div>
                </div>

                <div className="flex gap-5">
                  <div className="w-14 h-14 bg-[#F0F8FF] rounded-2xl flex items-center justify-center flex-shrink-0">
                    <Mail className="w-6 h-6 text-[#47ace2]" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-slate-900 font-outfit mb-1">Email</h3>
                    <a
                      href={`mailto:${companyInfo.email}`}
                      className="text-slate-600 hover:text-[#47ace2] font-manrope transition-colors"
                    >
                      {companyInfo.email}
                    </a>
                  </div>
                </div>

                <div className="flex gap-5">
                  <div className="w-14 h-14 bg-[#F0F8FF] rounded-2xl flex items-center justify-center flex-shrink-0">
                    <Clock className="w-6 h-6 text-[#47ace2]" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-slate-900 font-outfit mb-1">Working Hours</h3>
                    <p className="text-slate-600 font-manrope">{companyInfo.workingHours}</p>
                  </div>
                </div>
              </div>

              {/* Map */}
              <div className="mt-12 rounded-2xl overflow-hidden border border-slate-200">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3722.112002829018!2d79.10407119999999!3d21.1081004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd4bf0004056e43%3A0xb497d845fe92e849!2sModern%20Arch%20Builders%20and%20Developers!5e0!3m2!1sen!2sin!4v1778574687858!5m2!1sen!2sin"
                  width="100%"
                  height="350"
                  style={{ border: 0, display: 'block' }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Modern Arch Builders and Developers - Nagpur"
                />
              </div>
            </div>

            {/* Contact Form */}
            <div>
              <div className="bg-white border border-slate-100 rounded-2xl p-8 shadow-sm">
                <h2 className="text-2xl font-semibold text-slate-900 font-outfit mb-2">
                  Send Us a Message
                </h2>
                <p className="text-slate-600 font-manrope mb-8">
                  Fill out the form below and we'll get back to you within 24 hours.
                </p>
                <EnquiryForm />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
